import { useQuery } from "@tanstack/react-query";
import { getDepartment } from "../../api/apiDepartments";
import i18next from "i18next";

export function useGetDepartment(id) {
    const { isLoading, data: department, error } = useQuery({
        queryKey: ["departments", id, i18next.language],
        queryFn: () => getDepartment(id),
        enabled: !!id,
        retry: false,
    });

    return { isLoading, error, department };
}
